import React from 'react';
import LeadCaptureForm from '../LeadCaptureForm';

const Hero = () => {
  return (
    <section className="relative min-h-[800px] flex items-center overflow-hidden bg-surface-container-low">
      <div className="absolute inset-[0px] z-0">
        <img
          alt="Executive Traveler"
          className="w-full h-full object-cover object-center opacity-90"
          src="https://lh3.googleusercontent.com/aida-public/AB6AXuBHSeIQ9O6V4Ze2b_r62BF4UIpOFhneQNc8t6ZWpBtKvElesM5tK4ZunBFjuYW2SyMHV1O25fxSY9YfqCWikUEagtz3Y2_znBI0O2-RSGiGZOgdcUYTGHSL89mHYDVdjCxKPoj3IghH9OwLwJOOm70C7eV8_oogqNQEP9FQVxLO-gu-hNo4zMiOmDZ1_KflJB2I--MBk72AUVExn18m6D494ft4keY88Y1kF6gZvNCTs6Bom39PMnRMk-O7-0h76_58QBzsEEAsRJc"
        />
        <div className="absolute inset-[0px] bg-gradient-to-r from-background via-background/40 to-transparent"></div>
      </div>
      <div className="relative z-10 max-w-[1400px] mx-auto px-[32px] w-full grid md:grid-cols-2 gap-[48px] items-center">
        <div className="space-y-[32px]">
          <h1 className="font-headline text-[36px] md:text-[48px] font-extrabold tracking-tight text-on-surface leading-[1.1]">
            Reliable <span className="text-primary italic">Corporate Cab Services</span> & ETS in India
          </h1>
          <p className="text-body-lg text-on-surface-variant max-w-[512px] leading-relaxed text-[18px]">
            Pulpit Cabs provides data-driven corporate mobility and employee transportation services (ETS) across India. Elevate your executive travel with precision logistics, real-time intelligence, and a tech-enabled fleet tailored for enterprise needs.
          </p>
          <div className="flex gap-[16px] items-center pt-[16px]">
            <div className="flex -space-x-[12px]">
              <div className="w-[40px] h-[40px] rounded-full border-2 border-white flex items-center justify-center text-white text-[12px] font-semibold font-body" style={{ background: '#128884' }}>JS</div>
              <div className="w-[40px] h-[40px] rounded-full border-2 border-white flex items-center justify-center text-white text-[12px] font-semibold font-body" style={{ background: '#23a5a1' }}>AK</div>
              <div className="w-[40px] h-[40px] rounded-full border-2 border-white flex items-center justify-center text-white text-[12px] font-semibold font-body" style={{ background: '#40CDC8' }}>RM</div>
            </div>
            <span className="text-[14px] font-medium text-on-surface-variant">Trusted by 500+ Enterprises</span>
          </div>
        </div>
        <LeadCaptureForm />
      </div>
    </section>
  );
};

export default Hero;


